<script setup>
defineProps({
  title: {
    type: String,
  },
  summary: {
    type: String,
  },
  items: {
    type: Array,
  },
  width: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <!-- Questions Block -->
  <section
    class="three-column-link-list flex flex-wrap block-spacing mx-auto"
    :class="{
      'w-full max-w-177.5 eight-col-max': !width || width === '',
      'w-full max-w-238.5': width === 'wide',
    }"
  >
    <div class="three-column-link-list__header prose flex-1 w-full md:flex-auto !max-w-full mb-5">
      <h2
        v-if="title"
        class="three-column-link-list__title text-2xl font-bold"
      >
        {{ title }}
      </h2>
      <p
        v-if="summary"
        class="three-column-link-list__summary text-base mb-6"
      >
        {{ summary }}
      </p>
    </div>

    <div class="three-column-link-list__body w-100 flex-none basis-full md:flex-1">
      <div class="three-column-link-list__items md:flex md:flex-wrap md:-mx-6">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="three-column-link-list__item md:w-1/3 mb-6 md:px-6"
        >
          <ULink
            :to="useCmsUrl(item.url)"
            :locale="false"
            class="three-column-link-list__link underline font-bold text-med-dark-gray"
          >
            {{ item.text }}
          </ULink>
        </div>
      </div>
    </div>
  </section>
</template>
